import { ProductTypeError } from './product-type-form';

function normalizeName(value: string, label: string): string {
  const name = typeof value === 'string' ? value.trim() : '';
  if (!name) { throw new ProductTypeError('validation', 'El nombre de ' + label + ' es obligatorio.'); }
  if (name.length > 200) { throw new ProductTypeError('validation', 'El nombre no puede superar 200 caracteres.'); }
  return name;
}
export function normalizeAgencyName(value: string): string { return normalizeName(value, 'la agencia'); }
export function normalizeSubagencyName(value: string): string { return normalizeName(value, 'la subagencia'); }
export function normalizeZoneName(value: string): string { return normalizeName(value, 'la zona'); }
export function normalizeZoneStatus(value: number): 1 | 2 {
  if (value !== 1 && value !== 2) { throw new ProductTypeError('validation', 'Selecciona un estado válido.'); }
  return value;
}



// WEBPACK FOOTER //
// ./src/utils/administrative-catalog-form.ts